import axios from "axios";
import { axiosInstance } from "./intreceptor";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

class configService {
  updateConfig = (payload) => {
    return axiosInstance
      .post("/config/updateconfig", payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };

  getConfigData = (comp_id) => {
    return axiosInstance
      .get("/config/getconfigs",{params: {comp_id : comp_id}} )
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };

  getFeatureConfig = (comp_id) => {
    return axiosInstance
      .get("/config/get_config_features_data",{params: {comp_id : comp_id}} )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw err;
      });
  };

}

export default new configService();
